
import { Route, Routes } from 'react-router-dom';
import WebCreationPage from '../subscription/forms/WebCreationPage';
import UserOwnerForm from '../subscription/forms/ownerForm_page/UserOwnerForm';
import WebsiteForm from '../subscription/forms/settingsForm_page/WebsiteForm';
import PaymentForm from '../subscription/forms//paymentForm_page/PaymentForm';
import SignForm from '../client_pages/sign_pages/SignForm';
import Login from '../client_pages/sign_pages/Login';
import AdminPage from "../admin/AdminPage";
import { useContext, useEffect } from 'react';
import { AppContext } from '../../contextApi/ContextApi';
import WebingoSite from '../webingo/WebingoSite';
import NotFound404 from '../NotFound404';

export default function GeneralRoutes() {
  const {currentManagerUID, currentManager} = useContext(AppContext);
  return (
    <Routes>
        <Route path='/owner-creation-form' element={<WebCreationPage childForm={<UserOwnerForm/>} subject={"בוא נגדיר את המשתמש באמצעותו תנהל את האתר"} toPath={"/"}/>}/>
        <Route path='/website-creation-form' element={<WebCreationPage childForm={<WebsiteForm/>} subject={"בוא נגדיר את פרטי האתר הראשוניים"} toPath={"/webingo/owner-creation-form"}/>}/>
        <Route path='/payment-form' element={<WebCreationPage childForm={<PaymentForm/>} subject={"כעת לתשלום - לאחר מכן תועבר לעמוד התחברות ונתחיל בעבודה!"} toPath={"/webingo/website-creation-form"}/>}/>
        <Route path='/signin' element={<SignForm childForm={<Login/>} header={"התחבר עכשיו ל - "} isClient={false}/>}/>
        <Route path={`/admin_${currentManagerUID}/dashboard`} element={<AdminPage admin={currentManager} uid={currentManagerUID}/>}/>
        <Route path='/explore' element={<WebingoSite/>}/>
        <Route path='/*' element={<NotFound404/>}/>
    </Routes>
  )
}
